import { NSARouterMakerResult } from "namirasoft-account-react";
import { ChatInferencerType, InferencerType, LoadBalancerFullRow, LoadBalancerInputRow, LoadBalancerRow } from "namirasoft-inference";
import { NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { Component, Fragment } from "react";
import ChatList from "../components/ChatList";
import InferencerGraph from "../components/InferencerGraph";
import InferencerLoader from "../components/InferencerLoader";
import InferencerVisualizer from "../components/InferencerVisualizer";
import LoadBalancerTargetsView from "../components/LoadBalancerTargetsView";
import UsageChart from "../components/UsageChart";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface LoadBalancerViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class LoadBalancerViewPage extends Component<LoadBalancerViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout<LoadBalancerRow, LoadBalancerInputRow>
                {...this.props}
                action={{ description: InferenceInfo.load_balancer.view }}
                pages={{
                    entity: InferenceEntities.load_balancer(this.props),
                    view: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Chats",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) => model.id
                                                    ? <ChatList
                                                        {...this.props}
                                                        inferencer_type={ChatInferencerType.LOAD_BALANCER}
                                                        inferencer_id={model.id}
                                                    />
                                                    : null,
                                            },
                                            {
                                                title: "Usage",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) => model.id
                                                    ? <UsageChart
                                                        {...this.props}
                                                        inferencer_type={InferencerType.LOAD_BALANCER}
                                                        inferencer_id={model.id}
                                                    />
                                                    : null,
                                            },
                                        ],
                                    },
                                },
                            },
                            getChildrenAfter: (id, row) =>
                            {
                                if (!id || !row)
                                    return null;
                                let full = row as LoadBalancerFullRow;
                                return (
                                    <Fragment>
                                        <LoadBalancerTargetsView
                                            {...this.props}
                                            load_balancer_id={id}
                                            rows={full.targets ?? []}
                                        />
                                        <NSSpace size={NSSpaceSizeType.SMALL} />
                                        <InferencerLoader
                                            {...this.props}
                                            inferencer_type={InferencerType.LOAD_BALANCER}
                                            inferencer_id={id}
                                            render={({ tree, loading, error }) => (
                                                <Fragment>
                                                    <InferencerGraph tree={tree} loading={loading} error={error} />
                                                    <NSSpace size={NSSpaceSizeType.SMALL} />
                                                    <InferencerVisualizer tree={tree} loading={loading} error={error} />
                                                </Fragment>
                                            )}
                                        />
                                    </Fragment>
                                );
                            },
                        },
                    }
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}